import { render, staticRenderFns } from "./SearchTokenModal.vue?vue&type=template&id=5e9f0e2a&scoped=true&"
import script from "./SearchTokenModal.vue?vue&type=script&lang=js&"
export * from "./SearchTokenModal.vue?vue&type=script&lang=js&"
import style0 from "./SearchTokenModal.vue?vue&type=style&index=0&id=5e9f0e2a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9f0e2a",
  null
  
)

export default component.exports